import classNames from 'classnames'
import Tooltip from 'rc-tooltip'

import type { ReactElement } from 'react'

import Avatar from '~/components/Avatar'
import Label from '~/components/Label'
import UserCard from '~/components/UserCard'

import './styles.scss'

export const MAX_DISPLAYED_MEMBERS = 4

type User = {
  job?: string
  name: string
  picture?: string
}

export interface Props {
  className?: string
  label?: string
  labelPosition?: 'left' | 'top'
  size?: Exclude<SIZES, 'large'>
  users: User[]
}

const Team = ({ className, label, labelPosition = 'top', size = 'medium', users }: Props): ReactElement => {
  const teamWrapperClasses = classNames('team-wrapper', `${labelPosition}-label`, size)

  const memberClasses = classNames('member-container', size)

  const memberPlusClasses = classNames(memberClasses, 'member-plus-container')

  const teamClasses = classNames('team', className)

  return (
    <div className={teamWrapperClasses}>
      {label ? <Label className={'team-label'} label={label} size={size} /> : null}
      <div className={teamClasses}>
        {users.slice(0, MAX_DISPLAYED_MEMBERS).map(({ job, name, picture }, idx) => (
          <Tooltip
            key={`tooltip-key-${idx}`}
            mouseEnterDelay={0.3}
            overlay={
              <div className="tooltip-team-member">
                <UserCard name={name} picture={picture} subInfo={job} />
              </div>
            }
            placement="top"
            trigger="hover"
          >
            <div className={memberClasses}>
              <Avatar pictureUrl={picture} size={size} />
            </div>
          </Tooltip>
        ))}
        {users.length > MAX_DISPLAYED_MEMBERS ? (
          <Tooltip
            mouseEnterDelay={0.3}
            overlay={
              <div className="tooltip-team-member">
                {users.slice(MAX_DISPLAYED_MEMBERS).map(({ job, name, picture }, idx) => (
                  <UserCard key={`tooltip-picture-${idx}`} name={name} picture={picture} subInfo={job} />
                ))}
              </div>
            }
            placement="top"
            trigger="hover"
          >
            <div className={memberPlusClasses}>
              <span>+{users.length - MAX_DISPLAYED_MEMBERS}</span>
            </div>
          </Tooltip>
        ) : null}
      </div>
    </div>
  )
}

export default Team
